import { render } from "./ContentModule.vue?vue&type=template&id=31abffb8&scoped=true"
import script from "./ContentModule.vue?vue&type=script&lang=js"
export * from "./ContentModule.vue?vue&type=script&lang=js"

import "./ContentModule.vue?vue&type=style&index=0&id=31abffb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31abffb8"]])

export default __exports__